import { render, staticRenderFns } from "./LimitsTableRow.vue?vue&type=template&id=597f64da&"
import script from "./LimitsTableRow.vue?vue&type=script&lang=ts&"
export * from "./LimitsTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports